import TableSortable from "../../components/TableSortable";
import {IconButton, TableCell, Tooltip, Typography, Grid, withStyles} from "@material-ui/core";
import React, {useReducer} from "react";
import moment from "moment";
import * as PropTypes from "prop-types";
import Pendency from "../../forms/Pendency";
import PendencyObj from "../../models/pendency";
import {FileCopy, Description, BrokenImage} from "@material-ui/icons";
import {IconUpload as CloudUpload, IconAdicionar as AddIcon, IconExcluir as DeleteIcon} from "../../components/icons/MateraIcons";
import {withFb} from "../../contexts/FbProvider";
import {withDialog} from "../../contexts/DialogContext";
import {withNotification} from "../../contexts/NotificationContext";
import formatDate from "../../utils/formatDate";
import rows from "../../data/camposTabela";
import reducer from '../../utils/defaultReducer';
import SplitTempPendency from '../../forms/SplitTempPendency';
import {resolveDateDivider} from '../../utils/dateUtils';

const style = () => ({
    selectButtons: {
        minWidth: 120
    }

});

function ApontamentosTemp(props) {
    const initialState = {
        openDialog: false,
        dataDialog: PendencyObj,
        selected: [],
        openDeleteDialog: false,
    };

    const [state, setState] = useReducer(reducer, initialState, () => initialState)

    const clickRow = (data) => {
        setState({
            dataDialog: data
        })
        props.dialog.open({
            actions: null,
            noActionButtons: true,
            title: 'Editar Apontamento',
            content: <Pendency dateTime data={data} temp onSubmit={(initialValues, pendency) => {
                props.data.changePendencyWithDate(initialValues, pendency);
                setState({selected: []});
            }} onCancel={props.dialog.close}/>,
            size: 'md',
        })
    }

    const setSelected = (selected) => setState({selected: selected});

    const eraseSelected = () => props.dialog.open({
        actions: null,
        title: 'Excluir',
        noFullWidth: false,
        onAccept: onAcceptDelete,
        content: <Typography>Você deseja
            excluir {state.selected.length} {state.selected.length > 1 ? 'itens' : 'item'}?</Typography>,
        size: 'xs',
    });

    function validateDivisao(pendency) {
        const divider = resolveDateDivider(pendency)
        return (moment(divider).isBefore(moment(pendency.dataHoraFim)) && moment(divider).isAfter(moment(pendency.dataHoraInicio)));
    }

    const splitSelected = (pendency) => props.dialog.open({
        actions: null,
        title: 'Dividir Apontamento',
        noFullWidth: false,
        noActionButtons: true,
        content: <SplitTempPendency data={pendency} temp onSubmit={async (initialValues, pendency) => {
            if(!validateDivisao(pendency)){
                props.notification.notify({message: 'O horario da divisão deve ser entre horário de início e fim'});
            } else {
                await props.data.splitPendency(initialValues, pendency);
            }
            props.dialog.close()
        }}/>,
        size: 'xs',
    });

    const acoesApontamentos = {
        title: '',
        // width: 50,
        component: (state, prop, id, item) =>
            <>
                <Tooltip
                    title="Copiar Apontamento"
                    placement={'top'}
                    enterDelay={300}>
                    <div style={{width: 50}}>
                        <IconButton aria-label="Copiar" onClick={() => props.data?.selectPendency(item)}>
                            <FileCopy/>
                        </IconButton>
                    </div>
                </Tooltip>
                <Tooltip
                    title="Dividir Apontamento"
                    placement={'top'}
                    enterDelay={300}>
                    <div style={{width: 50}}>
                        <IconButton aria-label="Dividir" onClick={() => splitSelected(item)}>
                            <BrokenImage/>
                        </IconButton>
                    </div>
                </Tooltip>
            </>
    };

    const onAcceptDelete = () => props.data.removeSelecteds(state.selected).then(() => {
        setState({
            selected: []
        });
        props.dialog.close();
    });


    const setMultiSelecteds = () => props.data.setSelecteds(state.selected).then(() => {
        setState({
            selected: []
        })
    });

    const sendPendencies = async () => {
        if (state.selected?.length) {
            props.notification.notify({
                message: `Enviando ${state.selected?.length} apontamento${state.selected?.length > 1 ? 's' : ''}, aguarde.`,
                time: 20000,
                color: 'success'
            })
        }
        await props.data.sendPendencies(state.selected).then(() => {
            const qtdErr = props.listTempPendency.filter(pendency => pendency.status === 'error');
            if (qtdErr.length) {
                props.notification.notify({
                    message: `${qtdErr.length} apontamentos com erro.`
                });
            } else {
                props.notification.notify({
                    message: `Apontamentos enviados.`,
                    color: 'success'
                });
            }

            setState({selected: []});
        });
    };

    const actions = <Grid container direction={'row'} justifyContent={'flex-end'} className={props.classes.selectButtons}>
        <Tooltip title="Enviar">
            <IconButton aria-label="Enviar" onClick={sendPendencies}>
                <CloudUpload/>
            </IconButton>
        </Tooltip>
        <Tooltip title="Delete">
            <IconButton aria-label="Delete" onClick={eraseSelected}>
                <DeleteIcon/>
            </IconButton>
        </Tooltip>
        <Tooltip title="Atribuir Apontamento">
            <IconButton aria-label="Atribuir Apontamento" onClick={setMultiSelecteds}>
                <Description/>
            </IconButton>
        </Tooltip>
    </Grid>;

    const getFormatedDate = (value, item) => {
        if (value.format) {
            let newFormat = moment(value.field ? item[value.field] : item[value.id]);
            return newFormat.isValid() ? newFormat.format(value.format) : '';
        }
        return item[value.id];
    };
    const {classes, ...other} = props;
    return <>
        <TableSortable
            {...other}
            orderBy="dataHoraInicio"
            order="desc"
            selectActions={actions}
            tableTitle="Apontamentos Temporários"
            firstColumn={{...acoesApontamentos}}
            selected={state.selected}
            setSelected={setSelected}
            data={props.listTempPendency}
            checkbox
            rows={rows({tempList: true})}
            topActions={
                <Grid container direction={'row'} justifyContent={'flex-end'}>
                    <Tooltip title="Adicionar">
                        <IconButton aria-label="Adicionar apontamento" onClick={() => props.addTempPendency()}>
                            <AddIcon/>
                        </IconButton>
                    </Tooltip>
                </Grid>
            }
            idList={(item) => formatDate(item.dataHoraInicio)}
            renderCell={(item, rows, data) => rows.map((value, i) => {
                    if (value.hide)
                        return null;
                    return (<TableCell align="left" onClick={() => clickRow(item)} key={i} padding={'none'}>
                        {
                            getFormatedDate(value, item)
                        }
                    </TableCell>)
                }
            )}
        />
    </>;

}

ApontamentosTemp.propTypes = {
    onClickRow: PropTypes.func,
    idList: PropTypes.func,
    renderCell: PropTypes.func
};

export default withStyles(style)(withDialog(withNotification(withFb(ApontamentosTemp))));
